module.exports = "table {\n  white-space: nowrap; }\n\n.table-div {\n  max-width: 100%;\n  overflow: auto; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/bulk-renewal/component/bulk-renewal/bulk-renewal.component.scss
// module id = ./src/app/bulk-renewal/component/bulk-renewal/bulk-renewal.component.scss
// module chunks = main